import React, { useState } from 'react'
import OwlCarousel from "react-owl-carousel";
import { useSelector } from 'react-redux';
import { flightSearchRequest, setFlightSearchParams, setFlightSearchUrl } from '../../services/flight/searchServices';
import Moment from "moment";
import noImage from "./../../assets/images/no_image_offer.jpg"


const TopTravelDeals = () => {

  const deals = useSelector((state) => state.deals.data);
  const lang = useSelector((state) => state.culture.language);
  const culture = useSelector((state) => state.culture.currentCulture);
  const currency = useSelector(
    (state) => state.currencyDetails.currentCurrency
  );
  const [legParams, setLegParams] = useState([]);

  const currencyCountry = useSelector(
    (state) => state.currencyDetails.currencyCountry
  );


  const filteredFlightDeal = deals?.filter(function (data) {
    return data.DealGroup == 1;
  });

  const flightSearchAction = async (deal) => {

    let searchType = deal.SearchType;
    let sourceCode = deal.AirJourney[0].Source.Code;
    let destinationCode = deal.AirJourney[0].Destination.Code;
    let departureLabel = deal.AirJourney[0].Source.Name.en;
    let arrivalLabel = deal.AirJourney[0].Destination.Name.en;

    let departureLabelArabic = deal.AirJourney[0].Source.Name.ar;
    let arrivalLabelArabic = deal.AirJourney[0].Destination.Name.ar;

    let sourceCity = departureLabel.split("-")[0];
    let destinationCity = arrivalLabel.split("-")[0];

    let sourceCityArabic = departureLabelArabic.split("-")[0];
    let destinationCityArabic = arrivalLabelArabic.split("-")[0];

    let departAllAirport;
    if (deal.AirJourney[0].Source.IsAllAirport) {
      departAllAirport = "Y";
    } else {
      departAllAirport = "N";
    }

    let arrAllAirport;
    if (deal.AirJourney[0].Destination.IsAllAirport) {
      arrAllAirport = "Y";
    } else {
      arrAllAirport = "N";
    }

    let departDate;
    let arrivalDate;
    let type = " ";

    if (searchType == "OneWay") {

      type = 0;
      let responseFromDate = deal.AirJourney[0].Date;
      departDate = Moment(responseFromDate, "DD/MM/YYYY").format("DDMMMYYYY");
      //setDepartDate(Moment(responseFromDate,'DD/MM/YYYY').format("DDMMMYYYY"))
    } else if (searchType == "RoundTrip") {

      type = 1;
      let responseFromDate = deal.AirJourney[0].Date;
      departDate = Moment(responseFromDate, "DD/MM/YYYY").format("DDMMMYYYY");
      let responseToDate = deal.AirJourney[1].Date;
      arrivalDate = Moment(responseToDate, "DD/MM/YYYY").format("DDMMMYYYY");
      //setArrivalDate(Moment(responseToDate,'DD/MM/YYYY').format("DDMMMYYYY"))
    }


    let IsPreferredAirline = "all_flight";
    let preffAirlineLabel = "";
    let preffAirlineLabelArabic = "";

    if (deal.PrefferdAirline.Code != null && deal.PrefferdAirline.Name != null) {
      IsPreferredAirline = deal.PrefferdAirline.Code;
      preffAirlineLabel = deal.PrefferdAirline.Name.en;
      preffAirlineLabelArabic = deal.PrefferdAirline.Name.ar;
    }


    const searchParms = {
      deprtCode: sourceCode,
      arrivCode: destinationCode,
      departDate: departDate,
      returnDate: arrivalDate,
      adultCount: 1,
      childCount: 0,
      infantCount: 0,
      preffAirlineLabel: preffAirlineLabel,
      preffAirlineLabelArabic: preffAirlineLabelArabic,
      isNonStop: false,
      tripType: type,
      travelClass: "Economy",
      airline: IsPreferredAirline,
      deptAllAirport: departAllAirport,
      returnAllAirport: arrAllAirport,
      departLabel: departureLabel,
      arrivalLabel: arrivalLabel,
      departCity: sourceCity,
      arrivalCity: destinationCity,
      arrivalCityArabic: destinationCityArabic,
      departCityArabic: sourceCityArabic,
      arrivalLabelArabic: arrivalLabelArabic,
      departLabelArabic: departureLabelArabic,
    };
    

    let flightSearchData = await setFlightSearchParams(searchParms);


    let reqObj = {
      data: {
        from: sourceCode,
        to: destinationCode,
        fromDate: departDate,
        toDate: arrivalDate,
        adults: 1,
        childs: 0,
        infants: 0,
        travelClass: "Economy",
        nonStop: false,
        preferedAirline: IsPreferredAirline == "all_flight" ? "" : IsPreferredAirline,
        searchType: type,
        itenary: legParams,
        deptAllAirport: departAllAirport,
        returnAllAirport: arrAllAirport,
      },
      searchId: flightSearchData.data.searchId,
    };

    let searchResponse = await flightSearchRequest(reqObj, currency, currencyCountry);
    if (searchResponse) {
      //dispatch(setFlightSearchData(flightSearchData));

      let url = setFlightSearchUrl(flightSearchData.data, type, culture);

      //setRedirectUrl(url);
      window.location.href = url;
    }
  };

  if (filteredFlightDeal.length === 0) {
    return null;
  }
  return (
    <section className="travel_deal_section">
      <div className="container">
        <div className="HMLatestFDHead">
          <h4>{lang.top_travel_deals}</h4>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <OwlCarousel
              className="owl-theme"
              margin={40}
              dots
              responsive={{
                0: { items: 1 },
                600: { items: 2 },
                1000: { items: 4 },
              }}
              key={filteredFlightDeal[0].FareDetail.Currency}
            >
              {filteredFlightDeal.map((deal) => {
                return (
                  <div className="item" key={deal.UpdatedDate} onClick={() => flightSearchAction(deal)}>
                    <img
                      src={deal.DealImage.ImageUrl || noImage}
                      alt={`Travel deal from ${deal.AirJourney[0].Source.Code} to ${deal.AirJourney[0].Destination.Code}`}
                      onError={(e) => {
                        if (e.target.src !== noImage) {
                          e.target.src = noImage;
                        }
                      }}
                    />


                    <div className="caption d-flex">
                      <div className="col-lg-12 p-0">
                        <h4>
                          <span>{deal.AirJourney[0].Source.Code}</span>
                          <span><i className={`${deal.AirJourney.length == 1 ? 'deals_one_arrow' : 'deals_round_arrow'}`}></i></span>
                          <span>{deal.AirJourney[0].Destination.Code}</span>
                        </h4>
                        <h3>
                          <span>{deal.FareDetail.Currency}</span><span>{deal.FareDetail.Total}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                )
              })}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TopTravelDeals